/**
 * Transforma um array de objetos para o formato { id, nome }
 * @param lista - Array de objetos genéricos
 * @param chaveId - Uma das chaves existentes no objeto para ser o ID
 * @param chaveNome - Uma das chaves existentes no objeto para ser o Nome
 */
export function convertListSelect<T>(
  lista: T[], 
  chaveId: keyof T, 
  chaveNome: keyof T
): { id: any; nome: any }[] {
  return lista.map((item) => ({
    id: item[chaveId],
    nome: item[chaveNome],
  }));
}

/**
 * Extrai apenas os valores de uma chave específica de um array de objetos
 * @param lista - O array original
 * @param chave - A chave que queremos extrair (ex: 'id')
 * @returns Um array contendo apenas os valores daquela chave
 */
export function extrairIds<T, K extends keyof T>(lista: T[], chave: K): T[K][] {
  return lista.map(item => item[chave]);
}